<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.recommendation_lists.show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #091647">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Image Preview -->
          <div class="preview-container text-center my-3 col-12">
            <img
              v-if="data.image?.path"
              :src="data.image?.path"
              :alt="$t('PLACEHOLDERS.image')"
              style="max-width: 300px; max-height: 300px"
            />
          </div>
          <!-- End:: Image Preview -->

          <!-- Start:: Name AR Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <!-- End:: Name AR Input -->

          <!-- Start:: Name EN Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name EN Input -->

          <!-- Start:: Description AR Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            disabled
          />
          <!-- End:: Description AR Input -->

          <!-- Start:: Description EN Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            disabled
          />
          <!-- End:: Description EN Input -->

          <!-- Start:: Created At Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Active Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Active Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowRecommendationList",

  data() {
    return {
      // Start:: Data Collection
      data: {
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_en: null,
        description_ar: null,
        description_en: null,
        created_at: null,
        is_active: null,
      },
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Fetch Data
    async fetchData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `recommendation-lists/${this.$route.params?.id}`,
        });
        const item = res.data.data.RecommendationList;
        this.data.name_ar = item.name_ar;
        this.data.name_en = item.name_en;
        this.data.description_ar = item.description_ar;
        this.data.description_en = item.description_en;
        this.data.image.path = item.image;
        this.data.created_at = item.created_at;
        this.data.is_active = item.is_active == 1;
      } catch (error) {
        console.log(error?.response?.data?.message || error.message);
      }
    },
    // End:: Fetch Data
  },

  created() {
    this.fetchData();
  },
};
</script>
